import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20" {...props}><path d="M11.03 19.53a.75.75 0 00.073-.976l-.073-.084-8.467-8.468 8.467-8.469a.75.75 0 00.073-.976L11.03.472A.75.75 0 0010.054.4L9.97.473.972 9.471a.75.75 0 00-.072.977l.072.084L9.97 19.53a.749.749 0 001.06 0z" /></svg>);